/**
 * Section: system-steps
 * Custom element for accordion state and main image swapping.
 */
if (!customElements.get('system-steps-component')) {
  customElements.define(
    'system-steps-component',
    class SystemStepsComponent extends HTMLElement {
      // removed useless constructor
      connectedCallback() {
        this.setDefaultState();
        this.setMainImageFromFirstHeader();
        this.bindHeaderClicks();
      }

      disconnectedCallback() {
        if (this._imageSwapTimeout) {
          clearTimeout(this._imageSwapTimeout);
          this._imageSwapTimeout = null;
        }
        this.unbindHeaderClicks();
      }

      setDefaultState() {
        const items = this.querySelectorAll('.system-steps__accordion-item');
        if (!items.length) {
          return;
        }
        items.forEach((item) => item.classList.remove('is-active'));
        items[0].classList.add('is-active');
        this.querySelectorAll('.system-steps__accordion-header').forEach((btn, i) => {
          btn.setAttribute('aria-expanded', i === 0 ? 'true' : 'false');
        });
      }

      setMainImageFromFirstHeader() {
        const firstHeader = this.querySelector('.system-steps__accordion-header');
        if (!firstHeader) {
          return;
        }
        const src = firstHeader.getAttribute('data-image-src');
        if (!src) {
          return;
        }
        const mainImg = this.querySelector('.system-steps__media-wrapper img');
        if (mainImg) {
          mainImg.src = src;
        }
      }

      bindHeaderClicks() {
        this._onHeaderClick = this.onHeaderClick.bind(this);
        this.addEventListener('click', this._onHeaderClick);
      }

      unbindHeaderClicks() {
        if (this._onHeaderClick) {
          this.removeEventListener('click', this._onHeaderClick);
        }
      }

      onHeaderClick(event) {
        const header = event.target.closest('.system-steps__accordion-header');
        if (!header) {
          return;
        }

        const item = header.closest('.system-steps__accordion-item');
        if (!item) {
          return;
        }

        const accordion = item.closest('.system-steps__accordion');
        if (!accordion) {
          return;
        }

        accordion.querySelectorAll('.system-steps__accordion-item').forEach((sibling) => {
          sibling.classList.remove('is-active');
          const btn = sibling.querySelector('.system-steps__accordion-header');
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
          }
        });

        item.classList.add('is-active');
        header.setAttribute('aria-expanded', 'true');

        const imageSrc = header.getAttribute('data-image-src');
        if (imageSrc) {
          const mainImg = this.querySelector('.system-steps__media-wrapper img');
          if (mainImg) {
            if (this._imageSwapTimeout) {
              clearTimeout(this._imageSwapTimeout);
              this._imageSwapTimeout = null;
            }
            mainImg.style.opacity = '0';
            this._imageSwapTimeout = setTimeout(() => {
              this._imageSwapTimeout = null;
              mainImg.removeAttribute('srcset');
              mainImg.src = imageSrc;
              mainImg.style.opacity = '1';
            }, 300);
          }
        }
      }
    },
  );
}
